import { TranslationStatusOption } from '../../utils'

export enum TripStepTypeEnum {
  INBOUND = 'INBOUND',
  OUTBOUND = 'OUTBOUND'
}

export const tripStepTypeMapping: Record<TripStepTypeEnum, TranslationStatusOption> = {
  INBOUND: {
    label: 'trip.step.type.enum.INBOUND',
    variant: 'orange'
  },
  OUTBOUND: {
    label: 'trip.step.type.enum.OUTBOUND',
    variant: 'success'
  }
}
